import React, { createElement } from 'react';

import { MailIcon } from 'lucide-react';

import { Icon } from '@/shared/types/icon';

export const EmailIcon = ({
  size = 24,
  ref,
  ...props
}: Icon & { ref?: React.Ref<SVGSVGElement> }) => {
  return createElement(MailIcon, { ref, size, ...props });
};
